import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import api from '.';
import { CreateContactRequestDto } from '../dtos/requests/create-contact.request.dto';
import { BaseResponseDto } from '../dtos/responses/base.response.dto';
import { EmptyResponseDto } from '../dtos/responses/empty.response.dto';

const createContact = (
  data: CreateContactRequestDto,
): Promise<BaseResponseDto<EmptyResponseDto>> => {
  return api<BaseResponseDto<EmptyResponseDto>, CreateContactRequestDto>('/student/contact', {
    method: 'POST',
    data,
  });
};

export const useCreateContact = (
  options?: Omit<
    UseMutationOptions<BaseResponseDto<EmptyResponseDto>, unknown, CreateContactRequestDto>,
    'mutationFn'
  >,
) => {
  return useMutation<BaseResponseDto<EmptyResponseDto>, unknown, CreateContactRequestDto>({
    mutationFn: createContact,
    ...options, // 전달받은 옵션을 병합
  });
};
